import toast from "react-hot-toast";

import { nextCargoApi } from "@/store";

import { TruckSimple } from "../_shared";
import { TruckModel } from "./truckModels.types";

export const truckModelsApi = nextCargoApi.injectEndpoints({
  endpoints: (build) => ({
    //! Truck Models
    getTruckModels: build.query<TruckSimple[], void>({
      query: () => "/truck-model",
      onQueryStarted: async (args, { queryFulfilled }) => {
        toast.promise(queryFulfilled, {
          loading: "Carregando modelos de caminhão...",
          success: "Modelos de caminhão carregados com sucesso!",
          error: "Erro ao carregar modelos de caminhão."
        });
      }
    }),
    getTruckModel: build.query<Modifiers.Modify<TruckModel, { truckBrand: { id: number; name: string } }>, Pick<TruckSimple, "id">>({
      query: ({ id }) => `/truck-model/${id}`,
      onQueryStarted: async (args, { queryFulfilled }) => {
        toast.promise(queryFulfilled, {
          loading: "Carregando modelo de caminhão...",
          success: "Modelo de caminhão carregado com sucesso!",
          error: "Erro ao carregar modelo de caminhão."
        });
      }
    }),
    getTruckModelsByBrand: build.query<TruckSimple[], Pick<TruckModel, "truckBrand">>({
      query: ({ truckBrand }) => `/truck-model/brand/${truckBrand.id}`,
      onQueryStarted: async (args, { queryFulfilled }) => {
        toast.promise(queryFulfilled, {
          loading: "Carregando modelos de caminhão...",
          success: "Modelos de caminhão carregados com sucesso!",
          error: "Erro ao carregar modelos de caminhão."
        });
      }
    }),
    saveTruckModel: build.mutation<TruckSimple, Modifiers.Modify<TruckModel, { id: number | null }>>({
      query: (body) => ({
        url: `/truck-model/save`,
        method: "POST",
        body
      }),
      onQueryStarted: async (args, { queryFulfilled }) => {
        const isEdit = Boolean(args.id);
        toast.promise(queryFulfilled, {
          loading: isEdit ? "Atualizando modelo de caminhão..." : "Criando modelo de caminhão...",
          success: isEdit ? "Modelo de caminhão atualizado com sucesso!" : "Modelo de caminhão criado com sucesso!",
          error: isEdit ? "Erro ao atualizar modelo de caminhão." : "Erro ao criar modelo de caminhão."
        });
      }
    }),
    deleteTruckModel: build.mutation<void, Pick<TruckSimple, "id">>({
      query: ({ id }) => ({
        url: `/truck-model/delete/${id}`,
        method: "DELETE"
      }),
      onQueryStarted: async (args, { queryFulfilled }) => {
        toast.promise(queryFulfilled, {
          loading: "Excluindo modelo de caminhão...",
          success: "Modelo de caminhão excluído com sucesso!",
          error: "Erro ao excluir modelo de caminhão."
        });
      }
    })
  })
});

truckModelsApi.enhanceEndpoints({
  addTagTypes: ["TruckModel"],
  endpoints: {
    getTruckModels: {
      providesTags: (result) =>
        result ? [...result.map(({ id }) => ({ type: "TruckModel" as const, id })), { type: "TruckModel", id: "LIST" }] : [{ type: "TruckModel", id: "LIST" }]
    },
    getTruckModel: {
      providesTags: (result, error, { id }) => [{ type: "TruckModel", id }]
    },
    getTruckModelsByBrand: {
      providesTags: (result, error, { truckBrand }) => [{ type: "TruckModel", id: truckBrand.id }]
    },
    saveTruckModel: {
      invalidatesTags: ["TruckModel"]
    },
    deleteTruckModel: {
      invalidatesTags: (result, err, { id }) => [{ type: "TruckModel", id }]
    }
  }
});
